import { render } from "./displaymodulegnum.vue?vue&type=template&id=7dde4166"
import script from "./displaymodulegnum.vue?vue&type=script&lang=js"
export * from "./displaymodulegnum.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__